import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Messages } from 'primereact/messages'

import { PanelContainer } from '../../../../../components/Panel'
import { EmailChips } from '../../../../settings/EmailForm/EmailChips'
import { AddSupplierFormDto } from '../../data/model'
import { FormFieldName } from '../AddSupplier.form'

type Props = {
  formik: FormikProps<AddSupplierFormDto>
  separator: string
  isFormFieldInvalid: (name: FormFieldName) => boolean
  wrongSupportEmails: string[] | null
  getFormErrorMessage: (name: FormFieldName) => JSX.Element
  isRequestRunning: boolean
}
export const PrimaryContact: React.FC<Props> = ({
  formik,
  separator,
  isFormFieldInvalid,
  wrongSupportEmails,
  getFormErrorMessage,
  isRequestRunning,
}) => {
  const { t } = useTranslation()
  const panelId = 'addSupplier-email'
  const messagesRef = useRef<Messages>(null)

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.clear()
      messagesRef.current.show({
        id: '1',
        sticky: true,
        severity: 'info',
        detail: t('settings.email.notifications.message'),
        closable: false,
      })
    }
  }, [])

  return (
    <PanelContainer
      header={t('supplier.primaryContact.title')}
      id={panelId}
      toggleable={false}
    >
      <div className="grid">
        <div className="col-12 lg:col-4">
          <p>{t('supplier.primaryContact.subtitle')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <Messages ref={messagesRef} />

          {/* PrimaryContact */}
          <EmailChips
            id="supportValue"
            label={t('supplier.primaryContact.form.primaryContact.label')}
            value={formik.values.supportValue}
            separator={separator}
            formik={formik}
            isInvalid={isFormFieldInvalid('supportValue')}
            errorMessage={getFormErrorMessage('supportValue')}
            wrongEmails={wrongSupportEmails}
            disabled={isRequestRunning}
            isLoading={false}
          />
        </div>
      </div>
    </PanelContainer>
  )
}
